/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import router from '../router';
import baseUrl from '../../static/config.json';
import cookie from "../service/cookie";
import {message} from "../commonJs/ResetMessage";
import httpClient from './requestInterceptor';

/**
 * 提示函数
 * 显示2秒后关闭
 */
function tip(msg, type = 'error') {
  message({
    message: msg,
    type: type,
    duration: 2000,
    showClose: true
  });
}

let api_version = 'v2.7.1';

// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头改为 JSON
axios.defaults.headers.post['Content-Type'] = 'application/json';

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout') !== -1){
      tip('请求超时，请重新刷新页面');
      return;
    }
    if (error.response && error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: '/login',
            query: {redirect: router.currentRoute.fullPath}
          });
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          tip('登录过期，请重新登录');
          // 清除token
          cookie.setCookie('access_token_ul_wf', '');
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;
        // 404请求不存在
        case 404: {
          const normalized = {
            ...error.response,
            data: {
              code: 404,
              message: '接口未定义'
            }
          };
          tip(normalized.data.message);
          // 404 直接当作业务层可处理的结果返回
          return Promise.resolve(normalized);
        }
        // 500 服务器错误
        case 500: {
          const normalized = {
            ...error.response,
            data: {
              code: 500,
              message: '服务器错误'
            }
          };
          tip(normalized.data.message);
          return Promise.resolve(normalized);
        }
        default:
          tip(error.response.data.message);
      }
      return Promise.reject(error.response);
    }
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} Req [请求时携带的参数]
 */
function fetchGet(url, Req, apiType='base') {
  let params = {
    ver: api_version, // v1
    agent: 'pc', // mobile | pc | wx
    req: Req
  };

  // 根据 API 类型选择不同根路径（与 fetchUsrPost 保持一致）
  let base_url = baseUrl.API_ROOT;
  if(apiType == 'back_ul'){
    base_url = baseUrl.BACK_API_ROOT;
  }

  return new Promise((resolve, reject) => {
    axios.get(base_url + url, {
      headers: {
        'Content-Type': "application/json",
        'Authorization': cookie.getCookie('access_token_ul_wf')
      },
      params: params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      // 直接返回原始错误对象，便于上层统一处理
      reject(err);
    })
  });
}

/**
 * 使用 httpClient 的 post 方法（带 token 自动刷新）
 * @param {String} url [请求的url地址]
 * @param {Object} Req [请求时携带的参数]
 * @param {String} apiType [API类型]
 */
function fetchPost(url, Req, apiType='base') {
  // 统一构造请求体为 JSON
  let params = {
    ver: api_version,
    agent: 'pc',
    req: Req
  };

  // 根据 API 类型选择不同根路径
  let api_url = baseUrl.API_ROOT;

  if(apiType == 'back_ul'){
    api_url = baseUrl.BACK_API_ROOT;
  }

  if(apiType == 'downLoad'){
    api_url = 'https://1546043903304782.cn-beijing.fc.aliyuncs.com';
    params = Req;
  }

  if(apiType == 'record'){
    api_url = baseUrl.RECORD_API_ROOT;
  }

  const fullUrl = api_url + url;

  // 导出类接口适当放宽超时时间
  if(url.indexOf('Export') !== -1){
    axios.defaults.timeout = 60000;
  } else {
    axios.defaults.timeout = 10000;
  }

  if(cookie.getCookie('access_token_ul_wf') == null && !url.includes('UsrLogin')){
    tip('登录过期，请重新登录');
    router.replace({path: '/login'});
    return;
  }

  return new Promise((resolve, reject) => {
    httpClient.post(fullUrl, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export default {
  fetchGet: fetchGet,
  fetchPost: fetchPost
}



// WEBPACK FOOTER //
// ./src/request/request.js